import CIMSFormItem from 'components/CIMSFormItem'
import ReportSelect from 'components/CIMSSelect/common/ReportSelect'
import AdvancedOptions from './AdvancedOptions'
import { useGlobalState } from 'context/GlobalStateContext'
import { toMoments } from 'utils/toMoment'
import {
  CreateBatchReportRequestInput,
  useCreateBatchReportRequestMutation,
} from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import GenericRequest from '../../GenericRequest'
import { useCreationNotification } from '../../GenericRequest/hooks/useCreationNotification'
import { errorHandler } from 'hooks/errorHandler'

const Request: React.FC = () => {
  const {
    state: { projectGlobalId: projectId, createBatchReportRequestInput: input },
    dispatch: { updateCreateBatchReportRequestInput },
  } = useGlobalState()
  const created = useCreationNotification()
  const [create, { loading: creating }] = useCreateBatchReportRequestMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({ createBatchReportRequest: { batchReportRequest } }) =>
      created(batchReportRequest, 'Batch Report Request'),
  })
  return (
    <GenericRequest
      estimatesAreCalculatedBy="summing each selected Report type's last average time to generate by the total number of records returned with the configured Advanced Options. It does not include the time the request may need to wait in the Queue"
      request={{ name: 'Batch Report Request', type: 'reports' }}
      reduceEstimatesBy="adjusting Advanced Options to narrow results"
      errorMessagesInclude="the Report type associated with the error and the database ID used to attempt to generate the Report. Use this ID and Report type to generate a Single Report if desired"
      loading={creating}
      initialValues={{
        reportIds: input?.reportIds,
        payItemIds: input?.payItemIds,
        dateRange: toMoments([input?.dateRange?.from, input?.dateRange?.to]),
      }}
      onRequest={({ reportIds, dateRange, payItemIds }) => {
        if (!reportIds) return errorHandler('reportIds is not defined')
        if (!projectId) return errorHandler('projectId is not defined')
        const [from, to] = dateRange ?? []
        const input: CreateBatchReportRequestInput = {
          projectId,
          reportIds,
          payItemIds: payItemIds?.length ? payItemIds : undefined,
          // Using bang since if dateRange is truthy, then `from` and `to` must be present
          dateRange: dateRange
            ? { from: from!.toISOString(), to: to!.toISOString() }
            : undefined,
        }
        updateCreateBatchReportRequestInput(input)
        create({ variables: { input } })
      }}
    >
      <CIMSFormItem
        name="reportIds"
        label="Report(s)"
        requiredMessage="Please select one or more reports"
      >
        <ReportSelect multiple />
      </CIMSFormItem>
      <AdvancedOptions />
    </GenericRequest>
  )
}

export default Request
